import block from '@/mixins/block'
import Plyr from 'plyr'

export default {
  name: 'block_video',
  mixins: [block],
  data () {
    return {
      observer: undefined
    }
  },
  mounted () {
    if (this.data.url || this.data.file) {
      let autoplay = this.data.autoplay === false ? false : true
      if ((this.platform === 'mobile' || this.platform === 'tablet') && this.ua.platform.vendor === 'Apple') {
        autoplay = false
      }
      this.player = new Plyr(this.$refs['video'], {
        ratio: this.data.file ? '3:2' : '16:9',
        muted: autoplay,
        autoplay: autoplay,
        loop: { active: autoplay },
        vimeo: {
          byline: false,
          portrait: false,
          title: false,
          speed: true,
          transparent: true,
          background: true,
          playsinline: true,
          autoplay: autoplay,
          muted: autoplay
        }
      })
      this.player.on('play', () => {
        if (this.$refs['block-video-cover']) this.$refs['block-video-cover'].classList.add('hidden')
      })
      this.player.on('pause', () => {
        if (this.$refs['block-video-cover']) this.$refs['block-video-cover'].classList.remove('hidden')
      })

      this.observer = new IntersectionObserver(observables => {
        if (observables[0].intersectionRatio < 0.1) {
          this.player.pause()
        } else if (autoplay) {
          this.player.play()
        }
      }, {
        threshold: [0.1, 0.9]
      })
      this.observer.observe(this.$refs['video'])
    }
  },
  beforeDestroy () {
    if (this.observer) {
      this.observer.unobserve(this.$refs['video'])
    }
  }
}
